import React from 'react';
import {Outlet} from 'react-router-dom';
import './MarketsView.scss';
import DashboardContent from "@/components/dashboard/DashboardContent";

export default function MarketsView() {

    const links = [
        {
            text: 'Prior Approval Markets',
            url: '/dashboard/prior_approval_and_premium_markets/prior_approved',
        },
        {
            text: 'Premium Markets',
            url: '/dashboard/prior_approval_and_premium_markets/premium_markets',
        }
    ];

    return (
        <DashboardContent title={'Prior Approval & Premium Markets'} links={links} className={'markets_view'}>
            <Outlet/>
        </DashboardContent>
    );
};
